import { http } from 'services/http';
import type { ClientRes, CreateClientReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

type THandleSuccessFn = (data: ClientRes) => void;

interface ICreateClientMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

export const useCreateClient = (options?: ICreateClientMutationOptions) => {
  return useMutationBase<ClientRes, unknown, CreateClientReq>({
    mutationFn: async (variables) => {
      const res = await http.post<ClientRes>('/v1/clients', variables);

      return res.data;
    },
    onSuccess: options?.handleSuccess,
  });
};
